import {
  PaymentContainer,
  PaymentWrapper,
  PaymentWrap,
  Para,
  Button,
  ImageWrap,
  Image,
} from "./PayElements";
// import Learning from "../../images/onlineSkool.png";
import Learning from "../../images/slider2.png";
import { animateScroll as scroll } from "react-scroll";

const Payment = () => {
  const toggleHome = () => {
    scroll.scrollToTop();
  };

  return (
    <PaymentContainer id="pay">
      <PaymentWrapper>
        <ImageWrap>
          <Image loading="lazy" src={Learning} alt="LearningImage" />
        </ImageWrap>
        <PaymentWrap>
          <Para>
            Tell us us your children's need and enrol them for a home
            lesson tutoring session
          </Para>
          <Button to="/form" onClick={toggleHome}>
            Get Start
          </Button>
        </PaymentWrap>
      </PaymentWrapper>
    </PaymentContainer>
  );
};

export default Payment;
